/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MarkupDetails {
    getFixupPrototypeFunction() { return MarkupDetails.fixupPrototype; }

    static newInstance(model: Partial<MarkupDetails>): MarkupDetails {
        let obj = Object.assign(new MarkupDetails(), model);
        MarkupDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MarkupDetails>): MarkupDetails {
        if (!model) return null;
        return MarkupDetails.newInstance(<MarkupDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MarkupDetails) {
        if (!obj) return;

        models.MarkupDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MarkupDetails): boolean {
        Object.setPrototypeOf(obj, MarkupDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.markup_amount === undefined) {
            this.markup_amount = 0;
        }
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
        if (this.applicable_to) {
            models.ApplicableToDetails.fixupPrototype(this.applicable_to);
        }
    }

    /**
     * Start date of the rule
     */
    start_date: Date;

    /**
     * End date for that rule
     */
    end_date: Date;

    /**
     * Rule name. Enter an existing Rule name or else a new one will be created
     */
    rule_name: string;

    /**
     * Scope of the rule. This field cannot be updated use the same Rule Scope. If you want to update this create a new Rule
     */
    rule_scope: models.DiscountMarkupRuleScope;

    /**
     * Type of the markup/discount rule
     */
    rule_type: models.MarkupRuleType;

    /**
     * States if the rule is active or not
     */
    is_active: boolean;

    /**
     * Type of the markup
     */
    markup_type: models.DiscountMarkupType;

    /**
     * Markup/Discount amount depending on the  markup type selected
     */
    markup_amount: number;

    /**
     * Cloud Provider to select
     */
    service: models.CloudServiceName;

    /**
     * It is applicable to which cloud account or tenant based on rule scope. Cloud account Id can be retrieved from  api(/governance/account/{tenant_id}/get/cloud_accounts) This field cannot be updated enter the same one as entered before If you want to update this create a new Rule
     */
    applicable_to: models.ApplicableToDetails;

}
